import * as $ from 'jquery';
import 'bootstrap';
import 'slick';
import 'MagnificPopup';

export class videoRepositoryComponent{
	playVideo(): any{
		let _self = this;
		let $videoEmbedWrapper:any =  $('.video-embed--wrapper');
		let $videoExternalWrapper:any =  $('.video-external--wrapper');
		let $externalVideo: any = $('.external-video');
		let $firstThumbnail: any = $('.thumbnail-wrapper:first');
		let $videoRepPause: any = $('.video-repository .playpause');
		$('.embed-video').parent().click(function () {
			if($(this).children('.embed-video').get(0).paused){
					$(this).children('.embed-video').get(0).play();
					$(this).children('.playpause').fadeOut();
					$(this).children('.overlay-content').fadeOut();
					$(this).removeClass('gradient');
			}else{
				 $(this).children('.embed-video').get(0).pause();
					$(this).children('.playpause').fadeIn();
					$(this).children('.overlay-content').fadeIn();
					$(this).addClass('gradient');
			}
		});

		if($firstThumbnail.hasClass('external')){
			let $getVideoLink: any  = $firstThumbnail.attr('data-link');
			$videoExternalWrapper.show();
			$videoEmbedWrapper.hide();
			$externalVideo.prop("src", $getVideoLink);
		} else{
			let $getEmbedVideoLink: any  = $firstThumbnail.attr('data-link');
			let $getVideoPoster: any = $firstThumbnail.attr('data-poster');
			let $videoEmbedVideo: any = $('.video-embed--wrapper video');
			$videoEmbedVideo.prop("src", $getEmbedVideoLink);
			$videoEmbedVideo.prop("poster", $getVideoPoster);
			$videoEmbedWrapper.show();
			$videoExternalWrapper.hide();
		}

		$('.thumbnail-wrapper').on("click",function (e:any) {
			e.preventDefault();
			if($(this).hasClass('external')){
				let $videoEmbedVideo: any = $('.video-embed--wrapper video');
				$videoExternalWrapper.show();
				$videoEmbedWrapper.hide();
				let $getVideoLink: any  = $(this).attr('data-link');
				let $videoAutoplay: any = $getVideoLink+'?autoplay=1';
				$videoEmbedVideo.prop("src", '');
				$videoEmbedVideo.prop("poster", '');
				$externalVideo.prop("src", $videoAutoplay);
			} else {
				let $getEmbedVideoLink: any  = $(this).attr('data-link');
				let $getVideoPoster: any = $(this).attr('data-poster');
				let $videoEmbedVideo: any = $('.video-embed--wrapper video');
				let $overlayTitle: any = $('.video-embed--wrapper .overlay-content .title');
				let $overlayDesc: any = $('.video-embed--wrapper .overlay-content .description');
				let $getOverlayTitle: any = $(this).attr('data-title');
				let $getOverlayDesc: any = $(this).attr('data-description');
				$videoRepPause.css('display', 'block');
				$externalVideo.prop("src", '');
				$videoEmbedWrapper.show();
				$videoExternalWrapper.hide();
				$videoEmbedVideo.prop("src", $getEmbedVideoLink);
				$videoEmbedVideo.prop("poster", $getVideoPoster);
				$overlayTitle.html($getOverlayTitle);
				$overlayDesc.html($getOverlayDesc);
			}

		});
	}
	videoRepositorySlider(): any{
		$('.enrich-moments').slick({
			infinite: false,
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 2,
			dots: false,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
						prevArrow: false,
						nextArrow: false
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
	}

	videoRepositoryWatchVideo(): any{
		$('.watch-video').magnificPopup({
			disableOn: 0,
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false
		});
	}
}


let scope:Element = document.querySelector('.video-repository');
if (scope){
	try {
	let videorepositorycomponent = new videoRepositoryComponent();
			videorepositorycomponent.playVideo();
			videorepositorycomponent.videoRepositorySlider();
			videorepositorycomponent.videoRepositoryWatchVideo();
	} catch(e) {console.error(e);}
}
